<template>
    <div class="about-panel">
        <h1>What is this?</h1>
        <p>
            Play V:TES (Vampire: The Eternal Struggle) in a web browser against bots. A rules engine
            runs each game on engine.krcg.org and enforces the rules; the bots are trained by
            self-play and from the games people play here.
        </p>
        <p>
            The table is Succubus Club, the fan-made platform by Thomas Wajs, in a bots-only
            edition. It's free, with no ads and no accounts.
        </p>

        <p>
            Your decks and preferences stay in your browser's local storage. Each game is recorded
            on the engine's server, anonymously, and kept two years to improve the engine and the
            bots.
        </p>
    </div>
</template>
<script setup lang="ts"></script>
